module.exports = __webpack_public_path__ + "images/emoji/bullettrain_side.c0523a5f4417d234e379.png";